import BaseApi from '@core/api/model';

export class FeePlanApi extends BaseApi {
    static resource = 'fee-plans';
}

export default FeePlanApi;
